module.exports = __webpack_public_path__ + "img/chosen-icon.4995eefc.png";